import request from '@/utils/http';

/* 发票管理-列表页 - S */

// 查询
export const extsysInvoiceQuery = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/extsysInvoiceQuery',
        method: 'get',
        params
    });
};

// 保存
export const saveExtsysInvoice = data => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/saveExtsysInvoice',
        method: 'post',
        data
    });
};

// 删除
export const deleteExtsysInvoice = data => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/deleteExtsysInvoice`,
        method: 'post',
        data
    });
};

/* 发票管理-列表页 - E */

/* 发票管理-详情页 - S */

// 查询-发票明细
export const extsysInvoiceDtlQuery = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/extsysInvoiceDtlQuery',
        method: 'get',
        params
    });
};

// 保存-发票明细
export const saveExtsysInvoiceDtl = data => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/saveExtsysInvoiceDtl',
        method: 'post',
        data
    });
};
// 删除-发票明细
export const deleteExtsysInvoiceDtl = data => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/deleteExtsysInvoiceDtl',
        method: 'post',
        data
    });
};

// 导入-发票明细
export const importExtsysInvoiceDtl = (data) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/importExtsysInvoiceDtl`,
        method: 'post',
        data
    });
};

// 导出-发票明细
export const exportExtsysInvoiceDtl = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/exportExtsysInvoiceDtl',
        method: 'get',
        params,
        responseType: 'arraybuffer'
    }).then(res => {
        const blob = new Blob([res], {
            type: 'application/x-excel;charset=UTF-8'
        });
        const objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = '发票明细.xlsx';
        a.click();
    });
};

// 查询-发票内容
export const extsysInvoiceInfoQuery = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/extsysInvoiceInfoQuery',
        method: 'get',
        params
    });
};

// 保存-发票内容
export const saveExtsysInvoiceInfo = data => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/saveExtsysInvoiceInfo',
        method: 'post',
        data
    });
};
// 删除-发票内容
export const deleteExtsysInvoiceInfo = data => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/deleteExtsysInvoiceInfo',
        method: 'post',
        data
    });
};

// 导入-发票内容
export const importExtsysInvoiceInfo = (data) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/importExtsysInvoiceInfo`,
        method: 'post',
        data
    });
};

// 导出-发票内容
export const exportExtsysInvoiceInfo = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/exportExtsysInvoiceInfo',
        method: 'get',
        params,
        responseType: 'arraybuffer'
    }).then(res => {
        const blob = new Blob([res], {
            type: 'application/x-excel;charset=UTF-8'
        });
        const objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = '发票内容.xlsx';
        a.click();
    });
};

// 新增发票内容，自动带出发票内容相关信息字段-发票内容 ?apApplyNo=AA202403112893665&invoiceLabel=10
export const extsysInvoiceInfoRelateQuery = (params) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/extsysInvoiceInfoRelateQuery`,
        method: 'get',
        params
    });
};

// 信息确认 ?sysInvoiceNo=SYSAP202403110007
export const confirmExtsysInvoice = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/confirmExtsysInvoice',
        method: 'get',
        params
    });
};
// 取消信息确认 ?sysInvoiceNo=SYSAP202403110007
export const confirmExtsysInvoiceCancel = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/confirmExtsysInvoiceCancel',
        method: 'get',
        params
    });
};

// 提交开票 ?sysInvoiceNo=SYSAP202403110007
export const submitExtsysInvoice = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/submitExtsysInvoice',
        method: 'get',
        params
    });
};

// 红冲 ["SYSAP202403110117","SYSAP202403110118"]
export const rushExtsysInvoice = data => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/rushExtsysInvoice',
        method: 'post',
        data
    });
};

// 重开发票 ?sysInvoiceNo=SYSAP2024031100071111
export const remakeExtsysInvoice = params => {
    return request({
        url: '/api-bms-web/efApInvoiceHeader/remakeExtsysInvoice',
        method: 'get',
        params
    });
};

// 删除发票明细、内容、备注全部数据
export const deleteInvoiceBody = (jobId) => {
    if (!jobId) return;
    return new Promise((resolve, reject) => {
        const queryApis = [extsysInvoiceDtlQuery, extsysInvoiceInfoQuery];
        const params = { pageNo: 1, pageSize: 9999, sourceJobId: jobId };
        Promise.all(queryApis.map(el => el(params))).then(result => {
            const deleteApis = [deleteExtsysInvoiceDtl, deleteExtsysInvoiceInfo];
            const deleteQueue = [];
            result.map((itemRes, index) => {
                if (itemRes && +itemRes.code === 0) {
                    const deleteIds = itemRes.data.list.map(el => el.jobId);
                    deleteIds.length && deleteQueue.push(deleteApis[index](deleteIds));
                }
            });
            (deleteQueue.length || resolve()) && Promise.all(deleteQueue).then(resolve).catch(reject);
        }).catch(reject);
    });
};
